module.exports = __webpack_public_path__ + "media/images/img-family-4-2279529b.jpg";